import React, { useId } from "react";
import { Card, CardProps } from "./Card";
import { CheckCircle, SvgIconComponent } from "@mui/icons-material";
import { cn, keyboardTrigger } from "@/helpers/utils";

export interface RadioCardProps extends CardProps {
  value: boolean;
  id?: string;
  onChange: () => void;
  clear?: () => void;
  activeIcon?: SvgIconComponent;
  disabledIcon?: SvgIconComponent;
}

export const RadioCard = ({
  value,
  onChange,
  clear,
  id: idProp,
  activeIcon,
  disabledIcon,
  ...props
}: RadioCardProps) => {
  const Active = activeIcon ?? CheckCircle;
  const Icon = value ? Active : disabledIcon;
  const backupId = useId();
  const id = idProp ?? backupId;
  return (
    <div className="relative flex w-full flex-col">
      <input
        className="peer absolute opacity-0"
        id={id}
        type="radio"
        name="radio"
        checked={value}
        onChange={onChange}
        onClick={value ? clear : undefined}
        onKeyDown={value && clear ? keyboardTrigger(clear, "Space") : undefined}
      />
      <label
        className="grow cursor-pointer rounded-lg peer-focus:bg-primary-50 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-opacity-75"
        htmlFor={id}
      >
        <Card
          bordered={true}
          {...props}
          className={cn(
            "h-full max-w-none",
            value ? "border-primary" : "border-primary-200",
            props.className
          )}
          header={
            props.header ? (
              <Card.Header variant={value ? "secondary" : "gray"}>
                {props.header}
              </Card.Header>
            ) : undefined
          }
        >
          <div className="pr-8">{props.children}</div>
          {Icon && (
            <div className="pointer-events-none absolute right-4 top-0 z-10 h-full">
              <Icon className="text-primary" style={{ fontSize: 29 }} />
            </div>
          )}
        </Card>
      </label>
    </div>
  );
};
